import * as React from "react";
import type { SVGProps } from "react";
const SvgX = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" className="sociavore-icon" viewBox="0 0 24 24" width="1em" height="1em" {...props}><path d="M18 6 6 18M6 6l12 12" /></svg>;
export default SvgX;